function init() {

    const toggleList = document.querySelectorAll('[data-accordion-toggle]');

    toggleList.forEach((element) => {
        let sectionElement = element.parentNode,
            contentElement = sectionElement.querySelector('[data-accordion-content]');

        element.addEventListener('click', (event) => {
            let contentHeight;
            if(element.hasAttribute('data-lg-none')) {
               if($(window).width()>991) {
                   return;
               }
            }
            if (element.hasAttribute('data-calc')) {
                sectionElement = element.parentNode.parentNode;
                contentElement = sectionElement.querySelector('[data-accordion-content]');
            }
            sectionElement.classList.toggle('active');
            contentHeight = sectionElement.classList.contains('active') ? contentElement.scrollHeight+100 : 0;
            contentElement.setAttribute('style', 'max-height: ' + contentHeight + 'px');
        });
    });
};

export default {init};



// WEBPACK FOOTER //
// ./src/scripts/accordion-panel.js